import {gql} from 'graphql-request';

const GET_RECOMMENDED_PRODUCTS_QUERY = gql`
  query getRecommendedProducts(
    $type: RecommendationsType!
    $memberId: String
    $pageSize: Int
    $limit: Int
    $after: String
    $includeItemsInMyRegistry: Boolean
    $filter: ProductFilterParameter
    $sort: ProductsQuerySortParameter
  ) {
    recommendations(
      type: $type
      first: $pageSize
      after: $after
      limit: $limit
      memberId: $memberId
      filter: $filter
      includeItemsInMyRegistry: $includeItemsInMyRegistry
      sort: $sort
    ) {
      edges {
        node {
          id
          brand
          sku
          name
          url
          reviews {
            avgRating
            totalCount
          }
          variants {
            id
            color
            upc
            mediaGallery {
              url
            }
            offer {
              id
              price
            }
            selectedOptions {
              label
              key
              value
            }
            sku
          }
          priceRange {
            min
            max
          }
          options {
            key
            label
            values {
              label
              value
              swatch {
                type
                value
              }
            }
          }
          mostSpecificCategory {
            name
            url
            breadcrumbs {
              name
            }
          }
        }
      }
      totalCount
      pageCursors {
        around {
          page
          cursor
          isCurrent
        }
      }
    }
  }
`;

export default GET_RECOMMENDED_PRODUCTS_QUERY;
